import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function printRadPli(id: number) {
  return restApiClient.url(constructApiUrl(API.rads.printRadPli.url, { id })).post()
}
